<template>
  <div v-if="showModal" class="modal fade show d-block" tabindex="-1" role="dialog" aria-labelledby="googleDriveErrorModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="googleDriveErrorModalLabel">خطأ مصادقة جوجل درايف</h5>
          <button type="button" class="btn-close" @click="closeModal" aria-label="إغلاق"></button>
        </div>
        <div class="modal-body">
          <p>يبدو أنه كانت هناك مشكلة في الاتصال بجوجل درايف الخاص بك. قد يكون هذا بسبب:</p>
          <ul>
            <li>حساب جوجل الخاص بك غير مرتبط أو غير مصادق عليه.</li>
            <li>انتهاء صلاحية أذونات جوجل درايف.</li>
            <li>مشاكل في الشبكة.</li>
          </ul>
          <p>يرجى محاولة إعادة مصادقة اتصال جوجل درايف الخاص بك.</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="closeModal">إغلاق</button>
          <!-- Optionally, add a button to trigger re-authentication if you have a specific route/action for it -->
          <!-- <button type="button" class="btn btn-primary" @click="reauthenticate">Re-authenticate</button> -->
        </div>
      </div>
    </div>
  </div>
  <div v-if="showModal" class="modal-backdrop fade show"></div>
</template>

<script>
import { computed } from 'vue';
import { useStore } from 'vuex';

export default {
  name: 'GoogleDriveErrorModal',
  setup() {
    const store = useStore();
    const showModal = computed(() => store.getters['googleDrive/getGoogleDriveError']);

    const closeModal = () => {
      store.dispatch('googleDrive/setGoogleDriveError', false);
    };

    // If you have a re-authentication flow, you can add a method here
    // const reauthenticate = () => {
    //   // Trigger re-authentication logic, e.g., redirect to Google OAuth
    //   closeModal();
    // };

    return {
      showModal,
      closeModal,
      // reauthenticate,
    };
  },
};
</script>

<style scoped>
.modal {
  background-color: rgba(0, 0, 0, 0.5);
}
</style>